/* RESPONSIBLE TEAM: team-standalone */

import type { KnowledgeContentData } from './definitions';

export const GenericKnowledgeContentData: KnowledgeContentData = {
  heroBannerActions: [],
};

export const SalesforceKnowledgeContentData: KnowledgeContentData = {
  heroBannerActions: [
    {
      type: 'link',
      label: 'knowledge-hub.new-banner.actions.sync-articles-from-salesforce',
      icon: 'article',
      analyticsId: 'sync-articles-from-salesforce',
      onClick: () => {
        // @ts-expect-error We'll bind this later
        this.recordAnalyticsEvent('sync-articles-from-salesforce');
        window.Intercom('showArticle', 11086901); // https://fin.ai/help/en/articles/11086901-sync-content-from-your-salesforce-help-center
      },
    },
  ],
};

export const ZendeskKnowledgeContentData: KnowledgeContentData = {
  heroBannerActions: [
    {
      type: 'link',
      label: 'knowledge-hub.new-banner.actions.sync-articles-from-zendesk',
      icon: 'article',
      analyticsId: 'sync-articles-from-zendesk',
      onClick: () => {
        // @ts-expect-error We'll bind this later
        this.recordAnalyticsEvent('optimizing-content-for-fin-article');
        window.Intercom('showArticle', 10617194); // https://fin.ai/help/en/articles/10617194-sync-from-your-zendesk-help-center
      },
    },
  ],
};
